import { useState, useEffect } from 'react';
import { throttle } from '../domain/utils/throttle';
import { debounce } from '../domain/utils/debounce';

export const useWindowSize = ({
  throttleWait = 0,
  debounceWait = 0,
  triggerOnMount = false
} = {}) => {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined
  });

  const handleEventRaw = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  };

  let handleEvent = handleEventRaw;
  if (throttleWait) {
    handleEvent = throttle(handleEventRaw, throttleWait);
  }
  if (debounceWait) {
    handleEvent = debounce(handleEventRaw, debounceWait, false);
  }

  useEffect(() => {
    window.addEventListener('resize', handleEvent, {
      passive: true
    });

    if (triggerOnMount) {
      // Call handler right away so state gets updated with initial window size
      handleEvent();
    }

    return () =>
      window.removeEventListener('resize', handleEvent, {
        passive: true
      });
  }, []);

  return windowSize;
};
